/**
 * Created by Ning Jiang on 2021-05-27.
 */

import {IReelStateEventData, ReelState} from "../../../core/reel/ReelState";
import {DDay} from "../../DDay";
import {ReelStartPresentationController} from "../ReelStartPresentationController";
import {BlitzKriegSymbolState} from "../../symbol/DDaySymbolConfig";

export class ReelStartSoundController extends ReelStartPresentationController {

    constructor() {
        super('ReelStartSoundController');
    }

    public async start(): Promise<any> {
        await super.start();
    }

    protected onReelStart(data: IReelStateEventData): Promise<any> {
        DDay.reels[data.reelId].reelView.allSymbols.forEach((symbol) => {
            symbol.alpha = 1;
            DDay.reels[data.reelId].reelView.addRemoveWinSymbol(symbol, false);
        });
        return super.onReelSpin(data);
    }

    protected onReelSpin(data: IReelStateEventData): Promise<void> {
        return super.onReelSpin(data);
    }
}
